<ng-container *ngIf="initialized">

    <div class="grid">
        <!-- Left Column: Customer List (col-3) -->
        <div class="lg:col-3 col-12">
            <div class="h-full mvs-widget">
                <mvs-widget
                    *ngIf="customerListWidget"
                    [widgetData]="customerListWidget"
                    (onObjectSelect)="onCustomerSelect($event)"
                >
                </mvs-widget>
            </div>
        </div>

        <!-- Right Column: Insurance Details and Documents (col-9) -->
        <div class="lg:col-9 col-12">
            <div class="grid" *ngIf="insuranceDetailsWidget; else noSelectionMessage">
                <!-- Insurance List (col-8) -->
                <div class="lg:col-8 col-12">
                    <div class="h-full mvs-widget">
                        <mvs-widget
                            [widgetData]="insuranceDetailsWidget"
                            (onObjectSelect)="handleObjectSelect($event)"
                        >
                        </mvs-widget>
                    </div>
                </div>

                <!-- Documents Panel (col-4) - Copied from Versicherungen tab -->
                <div class="lg:col-4 col-12">
                    <p-card *ngIf="userAddedInsuranceDocumentDtoList?.entries?.length">
                        <div class="grid">
                            <section class="lg:col-3 col-12"
                                     *ngFor="let document of userAddedInsuranceDocumentDtoList?.entries">
                                <div class="card px-2">
                                    <div class="flex justify-content-between p-2">
                                        <h5 class="pdf-card-title text-sm">{{ document?.name }}</h5>
                                        <div class="flex gap-3">
                                            <i
                                                    class="pi pi-window-maximize cursor"
                                                    (click)="onDocumentSelect(document)"
                                            ></i>
                                        </div>
                                    </div>
                                    <div class="p-1">
                                        <mvs-pdf-viewer [objectId]="document.documentDtoId"
                                                        [documentMimeType]="document?.documentDto?.mimeType"
                                                        class="w-full"></mvs-pdf-viewer>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </p-card>
                </div>
            </div>
            <ng-template #noSelectionMessage>
                <p-card>
                    <p>Please select a customer from the list to view their insurance details.</p>
                    <p>Bitte wählen Sie einen Kunden aus der Liste, um die Versicherungsdetails anzuzeigen.</p>
                </p-card>
            </ng-template>
        </div>
    </div>

</ng-container>
